<template>
  <div class="xc-modal xc-modal-page">
    <div class="xc-modal-wrap">
      <div class="xc-modal-content">
        <div class="xc-modal-header">
          <div class="xc-modal-title">预览</div>
          <div class="xc-modal-close" @click.stop="layerClose"></div>
        </div>
        <div class="xc-card-content">
          <div class="xc-info">
            <div class="xc-info-content">
              <div class="xc-info-row">
                <div class="xc-info-item">素材名称：{{ program.name }}</div>
                <div class="xc-info-item">素材类型：{{ getType }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="xc-modal-body" v-if="program.type == 'image'">
          <div class="material myImg">
            <img class="myMaterial myImg" :src="program.url" />
          </div>
        </div>
        <div class="xc-modal-body" v-if="program.type == 'video'">
          <div class="material myVideo">
            <!-- <video
              class="myMaterial"
              :src="program.url"
            /> -->
            <video id="myVideo" class="video-js">
              <source :src="program.url" type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="xc-modal-body" v-if="program.type == 'web'">
          <div class="material web">
            <iframe class="myMaterial" :src="program.url"></iframe>
          </div>
        </div>
        <div class="xc-modal-body" v-if="program.type == 'audio'">
          <div class="material">
            <audio controls ref="audio" class="aud">
              <source :src="program.url" />
            </audio>
          </div>
        </div>
        <div class="xc-modal-footer xc-flex-center">
          <div class="xc-btn-group">
            <div class="xc-btn xc-btn-default" @click="layerClose">关闭</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myLayerImport from "@/libs/myLayer";
import Video from "video.js";
import "video.js/dist/video-js.css";

myLayerImport();

export default {
  name: "materialPreview",
  data() {
    return {
      // 来源渠道 0、节目编辑器（图片上传） 1、素材库（图片上传）
      channel: 0,
      program: this.$route.query,
    };
  },
  computed: {
    getType: function () {
      var text = "";
      switch (this.program.type) {
        case "image":
          text = "图片";
          break;
        case "video":
          text = "视频";
          break;
        case "web":
          text = "网页";
          break;
        case "audio":
          text = "音乐";
          break;
        default:
          break;
      }
      return text;
    },
  },
  mounted() {
    this.initVideo();
  },
  methods: {
    layerClose() {
      var index = parent.layer.getFrameIndex(window.name);
      parent.layer.close(index);
    },
    initVideo() {
      if (this.$route.query.type == "video") {
        //初始化视频方法
        let myPlayer = Video(myVideo, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: true,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          //设置视频播放器的显示宽度（以像素为单位）
          width: "951px",
          //设置视频播放器的显示高度（以像素为单位）
          height: "358px",
        });
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.material {
  // width: 100%;
  height: 100%;
  text-align: center;
  .myMaterial {
    width: 100%;
    height: 100%;
    border: 0;
  }
  .myImg {
    width: auto;
  }
}
</style>
